// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPalette.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INCreadDashboardDefinition.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

export default class ColorPalette {
  name = null;
  colors = null;
  displayName = null;
  isDefaultTheme = false;

  /**
   * Initial instant
   * @param {string} name
   * @param {Array<string>} colors
   * @param {boolean} isDefaultTheme
   */
  constructor(
    { name, colors, isDefaultTheme }: { name: string, colors: Array<string>, isDefaultTheme: boolean },
    displayName
  ) {
    this.name = name;
    this.colors = colors;
    this.isDefaultTheme = isDefaultTheme;
    this.displayName = name ? name : displayName;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ColorPalette.js